import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DiamRoleDetails,
  DiamTeamRoleUpdateRequest,
  diamQueryKeys,
  updateTeamRole,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export interface UpdateTeamRoleVariables {
  teamId: string;
  roleId: string;
  request: DiamTeamRoleUpdateRequest;
}

export function useUpdateTeamRole() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      teamId,
      roleId,
      request,
    }: UpdateTeamRoleVariables): Promise<DiamRoleDetails> => {
      const idToken = await getIdToken();
      return updateTeamRole(apiUrl, idToken, teamId, roleId, request);
    },
    onSuccess: (role, variables) => {
      queryClient.setQueryData(diamQueryKeys.role(variables.roleId), role);
      queryClient.invalidateQueries({ queryKey: ['diam', 'teams'] });
      queryClient.invalidateQueries({ queryKey: ['diam', 'roles'] });
    },
  });
}
